import React from 'react'
import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function SolidTicketIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M21 5H10v2c0 .6-.4 1-1 1s-1-.4-1-1V5H3c-.6 0-1 .4-1 1v4c0 .6.4 1 1 1s1 .4 1 1-.4 1-1 1-1 .4-1 1v4c0 .6.4 1 1 1h5v-2c0-.6.4-1 1-1s1 .4 1 1v2h11c.6 0 1-.4 1-1v-4c0-.6-.4-1-1-1s-1-.4-1-1 .4-1 1-1 1-.4 1-1V6c0-.6-.4-1-1-1Zm-11 8c0 .6-.4 1-1 1s-1-.4-1-1v-2c0-.6.4-1 1-1s1 .4 1 1v2Z"/>
  </SvgIcon>
}

export default SolidTicketIcon
